// src/icons.config.js
import bag from './Assets/Icons/Bag.svg';
import heart from './Assets/Icons/Heart.svg';
import user from './Assets/Icons/User.svg';
import bars from './Assets/Icons/bars.svg';
import line1 from './Assets/Icons/line1.svg';
import line2 from './Assets/Icons/line2.svg';
import mline1 from './Assets/Icons/mLine1.svg';
import mline2 from './Assets/Icons/mLine2.svg';
import flag from './Assets/Icons/indianflag.svg';
import arrow from './Assets/Icons/arrow.svg';
import customFit from './Assets/Icons/customFit.svg';
import luxuryFabrics from './Assets/Icons/luxuryFabrics.svg';
import modernStyles from './Assets/Icons/modernStyles.svg'
import aLine1 from './Assets/Icons/aboutLine1.svg';
import aLine2 from './Assets/Icons/aboutLine2.svg';
import amLine1 from './Assets/Icons/aboutMLine1.svg';
import amLine2 from './Assets/Icons/aboutMLine2.svg';
import previousArrow from './Assets/Icons/previousArrow.svg';
import nextArrow from './Assets/Icons/nextArrow.svg';
import collectionCircle from './Assets/Icons/collectionCircle.svg';
import collectionFlower from './Assets/Icons/collectionFlower.svg';
import collectionMFlower from './Assets/Icons/collectionMFlower.svg';
import collectionMCircle from './Assets/Icons/collectionMCircle.svg';
import footerCircles from './Assets/Icons/footerCircles.svg';
import mFooterCircles from './Assets/Icons/mFooterCircles.svg';
import brandPattern from './Assets/Icons/founderBrandPattern.svg';
import arrowLeft from './Assets/Icons/arrowLeft.svg';
import arrowRight from './Assets/Icons/arrowRight.svg';
import trendCircles from './Assets/Icons/trendCircles.svg';
import blogArrow from './Assets/Icons/blogArrow.svg';
import blogCircles from './Assets/Icons/blogCircles.svg';
import blogCirclesDown from './Assets/Icons/blogCirclesDown.svg';
import Filter from './Assets/Icons/Filter.svg';
import Expand_down from './Assets/Icons/Expand_down.svg';
import viewSmall from './Assets/Icons/viewSmall.svg';
import viewSmallLight from './Assets/Icons/viewSmallLight.svg';
import viewEnlargeLight from './Assets/Icons/viewEnlargeLight.svg';
import viewEnlarge from './Assets/Icons/viewEnlarge.svg';
import blogFlower1 from './Assets/Icons/blogFlower1.svg';
import blogFlower2 from './Assets/Icons/blogFlower2.svg';
import aboutUsFlower from './Assets/Icons/aboutUsFlower.svg';
import plus from './Assets/Icons/plus.svg';
import minus from './Assets/Icons/minus.svg';
import contactArrow from './Assets/Icons/contactArrow.svg';
import viewPageCircles from './Assets/Icons/viewPageCircles.svg';
import decreaseQ from './Assets/Icons/decreaseQ.svg';
import increaseQ from './Assets/Icons/increaseQ.svg';
import viewDressCirclesM from './Assets/Icons/viewDressCirclesM.svg';
import viewDressFlower1M from './Assets/Icons/viewDressFlower1M.svg';
import viewDressFlower2M from './Assets/Icons/viewDressFlower2M.svg';
import viewDressCircles2 from './Assets/Icons/viewDressCircles2.svg';
import viewLeftArrow from './Assets/Icons/viewLeftArrow.svg';
import viewRightArrow from './Assets/Icons/viewRightArrow.svg';
import viewClose from './Assets/Icons/viewClose.svg';
import noItemLiked from './Assets/Icons/noItemLiked.svg';
import filledHeart from './Assets/Icons/filledHeart.svg';
import emailTick from './Assets/Icons/emailTick.svg';
import close from './Assets/Icons/close.svg';
import emptyOrder from './Assets/Icons/emptyOrder.svg';
import offersIcon from './Assets/Icons/offersIcon.svg';
import couponsIcon from './Assets/Icons/couponsIcon.svg';
import dropdown from './Assets/Icons/dropdown.svg';
import closeFilter from './Assets/Icons/closeFilter.svg';
import emptyCart from './Assets/Icons/emptyCart.gif';
import trackOrderInitial from './Assets/Icons/trackOrderInitial.svg';
import trackOrderSecond from './Assets/Icons/trackOrderSecond.svg';
import copyCode from './Assets/Icons/copyCode.svg';
import eMail from './Assets/Icons/eMail.svg';
import phone from './Assets/Icons/phone.svg';
import address from './Assets/Icons/location.svg';
import back from './Assets/Icons/back_checkout.svg';
import  removeLikedItem from './Assets/Icons/removeLikedItem.svg';

const icons = {
  bag,                  //Navbar icon for cart
  heart,                //Navbar icon for liked items
  user,                 //Navbar icon for user profile
  bars,                 //Navbar icon for toggle button in smaller screens
  line1,                //Footer first doddle line in larger screens (lg and above)
  line2,                //Footer second doddle line in larger screens (lg and above)
  mline1,               //Footer first doddle line in smaller screens (md and below)
  mline2,               //Footer second doddle line in smaller screens (md and below)
  arrow,                //Footer arrow in subscribe to email button
  flag,                 //Indian flag icon in footer
  emailTick,
  customFit,            //Icon in about us section in home page
  luxuryFabrics,        //Icon in about us section in home page
  modernStyles,         //Icon in about us section in home page
  aLine1,               //About Us first doddle line in larger screens (lg and above)
  aLine2,               //About Us second doddle line in larger screens (lg and above)
  amLine1,              //About Us first doddle line in smaller screens (md and below)
  amLine2,              //About Us second doddle line in smaller screens (md and below)
  previousArrow,
  nextArrow,
  collectionFlower,
  collectionCircle,
  collectionMFlower,
  collectionMCircle,
  footerCircles,
  mFooterCircles,
  brandPattern,
  arrowLeft,
  arrowRight,
  trendCircles,
  blogArrow,
  blogCircles,
  blogCirclesDown,
  Filter,
  Expand_down,
  viewSmall,viewSmallLight,
  viewEnlargeLight,viewEnlarge,
  blogFlower1,
  blogFlower2,
  aboutUsFlower,
  plus,minus,
  contactArrow,
  viewPageCircles,decreaseQ,increaseQ,
  viewDressCirclesM,viewDressFlower1M,viewDressFlower2M,viewDressCircles2,viewLeftArrow, viewRightArrow,viewClose,noItemLiked,
  filledHeart,close,emptyOrder,offersIcon, couponsIcon,dropdown,closeFilter,
  emptyCart,
  trackOrderInitial,trackOrderSecond,
  copyCode,
  eMail,phone,address,back,
  removeLikedItem,

  
};

export default icons;
